import { object, string } from "yup";
import i18n from "i18n";
import Helper from "utils/helpers";

export const createConsulateValidate = object().shape({
  title: string().trim().required(i18n.t("errors.required")),
  emoji: string().trim().required(i18n.t("errors.required")),
  url: string().nullable(),
  description: string()
    .test(
      "empty-content",
      i18n.t("errors.required"),
      (value) => !Helper.checkEmptyHtmlRaw(value)
    )
    .required(i18n.t("errors.required")),
  contactInfo: string().nullable(),
});
